import { memo, useCallback } from "react";
import { Pressable } from "react-native";
import "@visioni/a3s-ui/theme";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { View, Text, Icon } from "@visioni/a3s-ui/components";

export type AccessListHeaderProps = {
  title: string;
  selectedCount: number;
  totalCount: number;
  collapsed: boolean;
  onToggle: () => void;
};

export const AccessListHeader = memo(
  ({ title, selectedCount, totalCount, collapsed, onToggle }: AccessListHeaderProps) => {
    const { theme } = useUnistyles();

    const handlePress = useCallback(() => {
      onToggle();
    }, [onToggle]);

    return (
      <Pressable onPress={handlePress} style={styles.header}>
        <View style={styles.titleRow}>
          <Text textStyle="md/semibold">{title}</Text>
          <Text textStyle="xs/regular" color="textMuted">
            {selectedCount}/{totalCount}
          </Text>
        </View>
        <Icon name={collapsed ? "chevronDown" : "chevronUp"} size={20} color={theme.colors.textMuted} />
      </Pressable>
    );
  },
);

const styles = StyleSheet.create((theme) => ({
  header: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: theme.spacing.md,
    paddingHorizontal: theme.spacing.md,
    userSelect: "none",
  },
  titleRow: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.sm,
  },
}));
